<template>
  <div class="button-wrap" :class="{'button-wrap--header': theme === 'header-btn'}">
    <div
      class="btn-transparent"
      :class="{'btn-transparent--white': theme === 'white', 'btn-transparent--header': theme === 'header-btn', 'btn-transparent--wide': wide === true, 'btn-transparent--left': mLeft === true}"
      @click="onBtnClick"
    >
      <span class="hover-out">
        <span class="hover-out_i">{{msg}}</span>
        <span class="btn-header-icon" v-if="theme === 'header-btn'"></span>
      </span>
      <span class="hover">
        <span class="hover_i">{{msg}}</span>
        <span class="btn-header-icon" v-if="theme === 'header-btn'"></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonSlider",
  props: {
    msg: {
      type: String,
      required: true,
      default: ""
    },
    theme: {
      type: String,
      required: false,
      default: "dark"
    },
    wide: {
      type: Boolean,
      required: false,
      default: false
    },
    mLeft: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onBtnClick() {
      this.$emit("btnClick");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.button-wrap {
  margin: 30px auto;
}
.button-wrap--header {
  display: inline-block;
  margin: 0;
}
.btn-transparent {
  height: 53px;
  line-height: 53px;
  text-align: center;
  font-size: 1.4rem;
  text-transform: uppercase;
  position: relative;
  color: $white-color;
  border: 1px solid $light-gray-color;
  overflow: hidden;
  outline: 0;
  transition-property: color, background;
  transition-duration: 0.4s;
  transition-timing-function: ease;
  width: 100%;
  max-width: 250px;
  margin: 0 auto;
  cursor: pointer;
  user-select: none;
}
.btn-transparent .hover-out {
  position: relative;
  z-index: 1;
  display: inline-block;
  animation: hoverOutInner 0.3s ease 1 forwards;
}
.btn-transparent .hover {
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: $dark-white-color;
  color: $black-color;
  z-index: 4;
  transform: translate(0, 100%);
  filter: alpha(Opacity=0);
  opacity: 0;
  animation: hoverOut 0.3s ease 1 forwards;
}
.btn-transparent:hover .hover-out {
  -webkit-animation-name: hoverInInner;
  -moz-animation-name: hoverInInner;
  -o-animation-name: hoverInInner;
  -ms-animation-name: hoverInInner;
  animation-name: hoverInInner;
}
.btn-transparent:hover .hover {
  -webkit-animation-name: hoverIn;
  -moz-animation-name: hoverIn;
  -o-animation-name: hoverIn;
  -ms-animation-name: hoverIn;
  animation-name: hoverIn;
}

/* theme modificatiors */
.btn-transparent--white {
  background-color: $white-color;
  color: $black-color;
}
.btn-transparent--header {
  background-color: $black-color;
  width: 180px;
}
.btn-transparent--white .hover {
  background-color: $black-color;
  color: $white-color;
}
.btn-transparent--wide {
  max-width: 100%;
}
.btn-transparent--left {
  margin-right: auto;
  margin-left: 0;
}

.btn-header-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 10px;
  background: url(../assets/price-list-icon-white.svg) no-repeat center center;
  background-size: contain;
}
.hover .btn-header-icon {
  background: url(../assets/price-list-icon-black.svg) no-repeat center center;
  background-size: contain;
}

@keyframes hoverOutInner {
  0% {
    transform: translate(0, 30px);
    filter: alpha(Opacity=0);
    opacity: 0;
  }

  100% {
    transform: translate(0, 0);
    filter: alpha(enabled=false);
    opacity: 1;
  }
}
@keyframes hoverOut {
  0% {
    transform: translate(0, 0);
    filter: alpha(enabled=false);
    opacity: 1;
  }

  100% {
    transform: translate(0, -100%);
    filter: alpha(Opacity=0);
    opacity: 0;
  }
}

@keyframes hoverInInner {
  0% {
    -moz-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    filter: alpha(enabled=false);
    opacity: 1;
  }

  100% {
    -moz-transform: translate(0, -30px);
    -ms-transform: translate(0, -30px);
    -webkit-transform: translate(0, -30px);
    transform: translate(0, -30px);
    filter: alpha(Opacity=0);
    opacity: 0;
  }
}
@keyframes hoverIn {
  0% {
    -moz-transform: translate(0, 100%);
    -ms-transform: translate(0, 100%);
    -webkit-transform: translate(0, 100%);
    transform: translate(0, 100%);
    filter: alpha(Opacity=0);
    opacity: 0;
  }

  100% {
    -moz-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    transform: translate(0, 0);
    filter: alpha(enabled=false);
    opacity: 1;
  }
}
</style>
